import axiosInstance from ".";

export const getBlogs = (term = "") => {
  return axiosInstance.get("/blogs", {
    params: {
      term: term, 
    },
  });
};


export const addBlogs = (data) => {
  return axiosInstance.post("/blogs", data);
};

export const updateBlogs = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/blogs/${id}`, payload);
};

export const deleteBlog = (id) => {
  return axiosInstance.delete(`/blogs/${id}`);
};

export const getBlogsBySlug = (query) => {
  return axiosInstance.get(`/blogs/${query?.queryKey?.[1]}`);
};

export const getBlogsPage = () => {
  return axiosInstance.get("/blogs-page");
};

export const addBlogsPage = (data) => {
  return axiosInstance.post("/blogs-page", data);
};

export const updateBlogsPage = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/blogs-page/${id}`, payload);
};